import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../../api/ApiRoutes";
import createRegulatorPortalInstance from "../../../api/RegulatorPortalInstance";
import { parseComplianceApproval } from "./parseComplianceApproval";
import { COMPLIANCE_RESULTS_LIST_QUERY_KEY } from "./useComplianceResultsList";
import { PROMOTABLE_SERVICES_QUERY_KEY } from "./usePromotableServices";
import type {
  ComplianceApprovalPayload,
  ComplianceApprovalResult,
} from "./types";

export const approveSelectedServices = async (
  payload: ComplianceApprovalPayload,
): Promise<ComplianceApprovalResult | null> => {
  const response = await createRegulatorPortalInstance().post(
    API_ROUTES.REGULATOR_COMPLIANCE_APPROVALS,
    payload,
  );
  return parseComplianceApproval(response.data);
};

export const useApproveSelectedServices = (): UseMutationResult<
  ComplianceApprovalResult | null,
  Error,
  ComplianceApprovalPayload
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["regulator-portal", "approve-selected"],
    mutationFn: approveSelectedServices,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PROMOTABLE_SERVICES_QUERY_KEY,
      });
      queryClient.invalidateQueries({
        queryKey: COMPLIANCE_RESULTS_LIST_QUERY_KEY,
      });
    },
  });
};
